export const VISIBLE = 'marketplace';
